import { ChallengeBaseResponseDto } from './challenge-base.response.dto';
import { Expose } from 'class-transformer';
import { IsOptional } from 'class-validator';

export class ChallengeInitMfaResponseDto extends ChallengeBaseResponseDto {
    @Expose()
    @IsOptional()
    otpAuthUri?: string;

    @Expose()
    @IsOptional()
    secretKey?: string;
}
